import type { ComponentType } from 'react';
import type { Permission } from '@sarha/shared';
import {
  IconAlert,
  IconBike,
  IconCalendar,
  IconChart,
  IconDashboard,
  IconDownload,
  IconFile,
  IconLock,
  IconMoney,
  IconReceipt,
  IconSettings,
  IconTag,
  IconShield,
  IconUsers,
  IconWallet,
} from '../components/icons';

export interface NavItem {
  to: string;
  label: string;
  permission: Permission;
  icon: ComponentType<{ width?: number; height?: number; className?: string }>;
  /** يظهر في شريط التنقل السفلي على الجوال */
  mobile?: boolean;
  group: 'التشغيل' | 'المالية' | 'التحليل' | 'الإدارة';
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/dashboard', label: 'لوحة المعلومات', permission: 'dashboard.view', icon: IconDashboard, mobile: true, group: 'التشغيل' },
  { to: '/daily', label: 'السجل اليومي', permission: 'daily.view', icon: IconCalendar, mobile: true, group: 'التشغيل' },
  { to: '/employees', label: 'السائقون', permission: 'employees.view', icon: IconUsers, mobile: true, group: 'التشغيل' },
  { to: '/vehicles', label: 'المركبات', permission: 'vehicles.view', icon: IconBike, group: 'التشغيل' },
  { to: '/renewals', label: 'التجديدات', permission: 'employees.view', icon: IconAlert, mobile: false, group: 'التشغيل' },
  { to: '/custody', label: 'العهد', permission: 'employees.view', icon: IconShield, mobile: false, group: 'التشغيل' },
  { to: '/payroll', label: 'الرواتب', permission: 'payroll.view', icon: IconWallet, mobile: true, group: 'المالية' },
  { to: '/payroll-target', label: 'تاركت الشهر', permission: 'payroll.view', icon: IconTag, group: 'المالية' },
  { to: '/expenses', label: 'مصروفات الشركة', permission: 'expenses.view', icon: IconReceipt, group: 'المالية' },
  { to: '/revenues', label: 'الإيرادات', permission: 'revenues.view', icon: IconMoney, group: 'المالية' },
  { to: '/reports', label: 'التقارير', permission: 'reports.view', icon: IconChart, mobile: true, group: 'التحليل' },
  { to: '/fiscal', label: 'الإقفال السنوي', permission: 'fiscal.view', icon: IconLock, group: 'التحليل' },
  { to: '/settings', label: 'الإعدادات', permission: 'settings.view', icon: IconSettings, group: 'الإدارة' },
  { to: '/users', label: 'المستخدمون والمشغلون', permission: 'users.view', icon: IconShield, group: 'الإدارة' },
  { to: '/permissions', label: 'إدارة الصلاحيات', permission: 'users.manage', icon: IconLock, group: 'الإدارة' },
  { to: '/import', label: 'الاستيراد من Excel', permission: 'data.import', icon: IconDownload, group: 'الإدارة' },
  { to: '/audit', label: 'السجل الرقابي', permission: 'audit.view', icon: IconFile, group: 'الإدارة' },
];

export const NAV_GROUPS = ['التشغيل', 'المالية', 'التحليل', 'الإدارة'] as const;

/**
 * الوجهة الافتراضية بعد الدخول: أول شاشة يملك الدور صلاحيتها.
 * دور «مطّلع على التقارير» مثلاً لا يملك لوحة المعلومات فيهبط على التقارير.
 */
export function landingPath(can: (permission: Permission) => boolean): string {
  return NAV_ITEMS.find((item) => can(item.permission))?.to ?? '/account';
}

/** روابط ثانوية لا تحتاج عنصراً مستقلاً في التنقل */
export const SECONDARY_ROUTES = {
  categories: '/expense-categories',
  suppliers: '/suppliers',
  profile: (id: string) => `/employees/${id}`,
  vehicle: (id: string) => `/vehicles/${id}`,
  payslip: (period: string, employeeId: string) => `/payroll/${period}/${employeeId}`,
};
